import { Create, SimpleForm, TextInput, useRedirect, useGetOne, SelectInput, Edit } from 'react-admin';
import { useState } from 'react';
import { useParams } from 'react-router-dom';

export const KeywordEdit = () => {

        return (
            <Edit title='Edit Keyword'>
                    <SimpleForm >
                        <TextInput label="Keyword" source="keyword" fullWidth />
                        <SelectInput fullWidth label="Status" source="status" choices={[
                            { id: '0', name: 'Inactive' },
                            { id: '1', name: 'Active' },
                        ]} />
                </SimpleForm>
            </Edit>
    );

}